import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import createDomPurify from 'dompurify';
import { CONSTANTS, routes } from '../Helpers/Configuration';
var urlParser = require('url');

const { defaultSanitizeOptions } = CONSTANTS;
const domPurify = createDomPurify(window);
const wrap = (val) =>{ return '"' + val + '"';};

//hrefs without a protocol can link the user to something relative like <APe>/{href url}
//    so this regex matches on the href tags so code can inject a protocol to any url
const regEx = new RegExp('hrefs*=s*"([^"]*)"', 'ig');

const HtmlFormattedMessage = props => {
    const intl = useIntl();
    const {
        descriptor,
        htmlString,
        sanitizeOptions
    } = props;
    function replaceAllPlaceholders(decodedHtml) {
        decodedHtml = decodedHtml || '';

        //Swap instaces of {RetrievalLink} to actual URL
        return decodedHtml.replaceAll(CONSTANTS.contentPlaceholders.appRetreivalLink, document.location.origin + routes.retrieval);
    }
    const html = useMemo(() => {
        let decodedHtml = decodeURI(descriptor ? intl.formatMessage(descriptor) : (htmlString || ''));
        try {
            decodedHtml = replaceAllPlaceholders(decodedHtml);

            let match;
            //For each match on href="url" ensure a protocol exists and then replace the href tag's property
            while((match = regEx.exec(decodedHtml)) !== null) {
                const rawUrl = match[1];
                const url = urlParser.parse(rawUrl);
                decodedHtml = decodedHtml.replace(wrap(rawUrl), wrap((url.protocol ? '' : 'https://') + url.href));
            }
        }
        catch {
            //Do nothing, return html as it
        }

        return domPurify.sanitize(decodedHtml, {
            ...defaultSanitizeOptions, 
            ...sanitizeOptions,
            ADD_ATTR: ['target', 'rel'] // Explicitly allow `target` and `rel` attributes
        });
    }, [descriptor, htmlString, sanitizeOptions]);

    return (<span dangerouslySetInnerHTML={{ __html: html }}></span>);
};

HtmlFormattedMessage.propTypes = {
    descriptor: PropTypes.object,
    htmlString: PropTypes.string,
    sanitizeOptions: PropTypes.object
};

export default HtmlFormattedMessage;